<template>
  <div class="container">
    <app-header title="搜索" />
    <!-- 搜索 -->
    <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;margin-right: 12px;">
      <div class="search">
        <div class="left">
          <img src="@/assets/search.png"
               alt="搜索"
               class="search-icon">
        </div>
        <div class="right">
          <input v-model.trim="name"
                 @search="search"
                 type="search"
                 placeholder="搜索商品名称或型号"
                 class="search-input">
        </div>
      </div>
      <div class="search-btn">
        <van-button type="primary" size="small" color="#fe003b " style="border: 1px solid #fe003b ;" @click="search">搜索</van-button>
      </div>
    </div>
    <div class="hot">
      <div class="title">大家都在搜索</div>
      <div class="content">
        <div class="item"
             v-for="item in productList"
             :key='item.id' @click="gotoSearchProduct(item)">{{item.name}}</div>
      </div>
    </div>
    <div class="hot">
      <div style="display: flex;flex-direction: row;justify-content: space-between">
        <div class="title">历史搜索</div>
        <img src="@/assets/del.png" alt="" width="25px" height="25" @click="handleDelete">
      </div>
      <div class="content">
        <div class="item"
             v-for="(item,index) in nameList"
             :key='index'
             v-if="index<10" @click="gotoSearchProductHis(item)">{{item}}</div>
      </div>
    </div>
  </div>
</template>

<script>

import { getShopProductList,queryShopProductPage, getSearchLog} from '@/api/product'

export default {
  name: 'Index',
  data () {
    return {
      name: '',
      nameList: [],
      productList: null
    }
  },
  created () {
    this.queryShopProductPage()
    this.getHistoryList()
  },
  methods: {
    getHistoryList(){
      if (localStorage.getItem('nameList')) {
        this.nameList = JSON.parse(localStorage.getItem('nameList'))
        var newList = []
        for (var i = 0; i < this.nameList.length; i++) {
          if (i < 7) {
            newList.push(this.nameList[i])
          }
        }
        this.nameList = newList
      }
    },
    clearHistory(){
      localStorage.removeItem('nameList')
      this.nameList = [];
    },
    handleDelete(){
      this.$dialog.confirm({
        title: '是否确认删除历史记录'
      }).then(() => {
        this.clearHistory()
      }).catch(() => {

      });
    },
    searchList () {
      console.log('斤斤计较')
    },
    queryShopProductPage () {
      const params = {
        page: 1,
        limit: 6,
        query: {

        }
      }
      queryShopProductPage(params).then((res) => {
        if (res.success) {
          this.productList = res.data.records
        }
      })
    },

    getSearchLog () {
      getSearchLog({}).then((res) => {
        if (res.success) {

        }
      })
    },
    search(){
      this.gotoSearchProduct({name: this.name});
    },
    gotoSearchProduct(item) {
      if (item != undefined) {
        this.name = item.name
      }
      if (this.name == '') {
        return
      }

      for (var i = 0; i < this.nameList.length; i++) {
        if (this.nameList[i] == item.name) {
          this.nameList.splice(i,1)
          break
        }
      }
      var newList = []
      newList.push(item.name)
      for (var i = 0; i < this.nameList.length; i++) {
        newList.push(this.nameList[i])
      }
      localStorage.setItem('nameList', JSON.stringify(newList))
      this.$router.push({
        path: '/searchProduct',
        query:{
          name: this.name
        }
      })
    },
    gotoSearchProductHis(item) {
      if (item != undefined) {
        this.name = item
      }
      if (this.name == '') {
        return
      }
      this.$router.push({
        path: '/searchProduct',
        query:{
          name: this.name
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100vw;
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: scroll;
  font-size: 14px;
  background-color: #ffffff;
  .search {
    height: 36px;
    margin: 6px 12px;
    border: 1px solid #fe003b;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    .left {
      .search-icon {
        width: 23px;
        height: 23px;
        margin-right: 5px;
        margin-left: 10px;
      }
    }
    .right {
      width: 100%;
      .search-input {
        display: block;
        box-sizing: border-box;
        width: 100%;
        min-width: 0;
        margin: 0;
        padding: 0;
        color: #323233;
        font-size: 14px;
        line-height: 20px;
        text-align: left;
        background-color: transparent;
        border: 0;
        resize: none;
      }
    }
  }
  .hot {
    padding: 0 12px;
    margin-top: 18px;
    .title {
      height: 22px;
      font-size: 16px;
      font-weight: bold;
      line-height: 21px;
      color: rgba(51, 51, 51, 1);
    }
    .content {
      margin-top: 14px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .item {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        height: 30px;
        line-height: 30px;
        background: rgba(242, 242, 242, 1);
        border-radius: 15px;
        padding: 0 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 10px;
        margin-right: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/search/index.vue